import { AccountsScopesPermissions } from "./accounts-scopes.permissions";
import { AccountsPermissions } from "./accounts.permissions";
import {AccountsSpecializedRolesPermissions} from "./accounts-specialized-roles.permissions";
import {AccountsUsersPermissions} from "./accounts-users.permissions";
import { PermissionsPermissions } from "./permissions.permissions";
import { ScopesPermissionsPermissions } from "./scopes-permissions.permissions";
import { ScopesPermissions } from "./scopes.permissions";
import { AccountsUsersSpecializedRolesPermissions } from "./accounts-users-specialized-roles.permissions";
import { AccountsSpecializedRolesPermissionsPermissions } from "./accounts-specialized-roles-permissions.permissions";
import { AccountsUsersSpecializedRolesPermissionsPermissions } from "./accounts-users-specialized-roles-permissions.permissions";
import { UsersPermissions } from "./users.permissions";
import { SystemRolesPermissions } from "./system-roles.permissions";
import { AccountTypesPermissions } from "./account-types.permissions";
export class UserManagementPermissions {

  static Accounts = AccountsPermissions.Permissions;
  static AccountsScopes = AccountsScopesPermissions.Permissions;
  static AccountsSpecializedRoles = AccountsSpecializedRolesPermissions.Permissions;
  static AccountsSpecializedRolesPermissions = AccountsSpecializedRolesPermissionsPermissions.Permissions;
  static AccountsUsers = AccountsUsersPermissions.Permissions;
  static AccountsUsersSpecializedRoles = AccountsUsersSpecializedRolesPermissions.Permissions;
  static AccountsUsersSpecializedRolesPermissions = AccountsUsersSpecializedRolesPermissionsPermissions.Permissions;
  static Scopes = ScopesPermissions.Permissions;
  static ScopesPermissions = ScopesPermissionsPermissions.Permissions;
  static Users = UsersPermissions.Permissions;
  static SystemRoles = SystemRolesPermissions.Permissions;
  static Permissions = PermissionsPermissions.Permissions;

  static AccountTypes = AccountTypesPermissions.Permissions;
  }


export function getUserManagementModuleName() {
  return 'UserManagement';
}
